import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "./../../../component/atoms/input/mainInput";
import DateInput from "./../../../component/atoms/input/dateInput";
import Checkbox from "./../../../component/atoms/input/checkbox";
import Radio from "./../../../component/atoms/input/radio";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import RedBtn from "./../../../component/atoms/button/redBtn";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";

import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";

import CouponApi from "../../../api/coupon.api";
import GroupApi from "../../../api/group.api";
import moment from "moment";
import CategoryApi from "../../../api/category.api";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";
import RelatedProductsPopup from "../../../component/templates/modal/relatedProductsPopup";

const OperationCouponCreate = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");

  // ---------- 쿠폰 형식 관련 ---------- //
  const [selectedRadio, setSelectedRadio] = useState("지정발행");

  // ---------- 발행대상 관련 ---------- //
  const [selectedTarget, setSelectedTarget] = useState("전체회원");
  const [targetListBoxOpen, setTargetListBoxOpen] = useState(false);
  const targetList = [
    {
      title: "전체회원",
      value: "전체회원",
    },
    {
      title: "지정그룹",
      value: "지정그룹",
    },
  ];

  // 자동발행 선택 시
  const [autoTargetListOpen, setAutoTargetListOpen] = useState(false);
  const [selectedAutoTarget, setSelectedAutoTarget] = useState("첫 회원가입");
  const autoTargetList = [
    {
      title: "첫 회원가입",
      value: "첫 회원가입",
    },
    {
      title: "첫 구매완료 직후",
      value: "첫 구매완료 직후",
    },
  ];

  useEffect(() => {
    setTargetListBoxOpen(false);
    setAutoTargetListOpen(false);

    setSelectedPeriodType("기간설정");
  }, [selectedRadio]);

  // 지정그룹 선택 시
  const [groupList, setGroupList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(0);
  const [groupListBoxOpen, setGroupListBoxOpen] = useState(false);

  const [categoryList, setCategoryList] = useState([]);
  // 지정 카테고리 선택 시
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryListBoxOpen, setCategoryListBoxOpen] = useState(false);

  useEffect(() => {
    setSelectedGroup(0);
  }, [selectedTarget]);

  useEffect(() => {
    getNormalGroupList();
    getMainCategoryList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 일반 그룹 가져오기
  const getNormalGroupList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
      };

      const response = (await GroupApi.getList(data)).data.data.content;

      let groupTemp = response.map((item) => {
        return { title: item.title, value: item.id };
      });
      setGroupList(groupTemp);
    } catch (error) {
      errorHandler(error);
    }
  };

  //  상품 카테고리 가져오기
  const getMainCategoryList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
      };
      const response = (await CategoryApi.getListMain(data)).data.data.content;

      let temp = response.map((item) => {
        return {
          value: item.id,
          title: item.title,
        };
      });

      setCategoryList(temp);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 발행알림 관련 ---------- //
  const [selectedAlarm, setSelectedAlarm] = useState("발행일에 알림");
  const [alarmListBoxOpen, setAlarmListBoxOpen] = useState(false);
  const alarmList = [
    {
      title: "발행일에 알림",
      value: "발행일에 알림",
    },
    {
      title: "알림 안함",
      value: "알림 안함",
    },
  ];

  // ---------- 쿠폰코드 관련 ---------- //
  const [selectedCouponType, setSelectedCouponType] = useState("단일 쿠폰코드");

  const [couponTypeListBoxOpen, setCouponTypeListBoxOpen] = useState(false);

  const couponTypeList = [
    {
      title: "단일 쿠폰코드",
      value: "단일 쿠폰코드",
    },
    {
      title: "여러 쿠폰코드",
      value: "여러 쿠폰코드",
    },
  ];

  // ---------- 사용혜택 관련 ---------- //
  const [selectedBenefit, setSelectedBenefit] = useState("금액할인");
  const [benefitListBoxOpen, setBenefitListBoxOpen] = useState(false);
  const benefitList = [
    {
      title: "금액할인",
      value: "금액할인",
    },
    {
      title: "수강권 혜택",
      value: "수강권 혜택",
    },
  ];

  const [selectedDiscountType, setSelectedDiscountType] = useState("KRW");
  const [discountTypeListBoxOpen, setDiscountTypeListBoxOpen] = useState(false);
  const discountTypeList = [
    {
      title: "KRW",
      value: "KRW",
    },
    {
      title: "%",
      value: "%",
    },
  ];

  // 수강권 혜택 선택 시
  const [selectedTicket, setSelectedTicket] = useState("");
  const [ticketListBoxOpen, setTicketListBoxOpen] = useState(false);
  const ticketList = [
    {
      title: "1년 수강권",
      value: "1년 수강권",
    },
    {
      title: "평생 수강권",
      value: "평생 수강권",
    },
  ];

  // ---------- 쿠폰 적용 범위 관련 ---------- //
  const [selectedRange, setSelectedRange] = useState("모든 상품");
  const [rangeListBoxOpen, setRangeListBoxOpen] = useState(false);
  const rangeList = [
    {
      title: "모든 상품",
      value: "모든 상품",
    },
    {
      title: "지정 카테고리",
      value: "지정 카테고리",
    },
    {
      title: "지정 상품",
      value: "지정 상품",
    },
  ];

  // 쿠폰 적용 상품 선택 팝업
  const [couponApplyProductPopupOpen, setCouponApplyProductPopupOpen] =
    useState(false);

  // 쿠폰 제외 상품 선택 팝업
  const [eCouponApplyProductPopupOpen, setECouponApplyProductPopupOpen] =
    useState(false);

  // ---------- 기간 관련 ---------- //
  const [selectedPeriodType, setSelectedPeriodType] = useState("기간설정");
  const [noPeriodLimit, setNoPeriodLimit] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [expiredDay, setExpiredDay] = useState(0);

  const [allowDuplicate, setAllowDuplicate] = useState(false);
  const [maxDiscountAmount, setMaxDiscountAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [minBuyAmount, setMinBuyAmount] = useState(0);
  const [issueCount, setIssueCount] = useState(0);
  const [isIssueCountInfinity, setIsIssueCountInfinity] = useState(false);

  const [couponCode, setCouponCode] = useState("");
  const [merchIdList, setMerchIdList] = useState([]);
  const [exceptionMerchIdList, setExceptionMerchIdList] = useState([]);

  useEffect(() => {
    if (isIssueCountInfinity) {
      setIssueCount(0);
    }
  }, [isIssueCountInfinity]);

  const generateRandomString = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 10; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  };

  useEffect(() => {
    if (selectedRange) {
      setMerchIdList([]);
    }
  }, [selectedRange]);

  function isNumericString(str) {
    const regex = /^\d+$/;
    return regex.test(str);
  }

  const createProductFunc = async () => {
    try {
      if (!isNumericString(String(issueCount))) {
        return toast("쿠폰코드 발급수량은 숫자만 입력가능합니다");
      }

      if (
        !isNumericString(String(discountAmount)) ||
        !isNumericString(String(minBuyAmount)) ||
        !isNumericString(String(maxDiscountAmount))
      ) {
        return toast("숫자만 입력가능합니다");
      }

      if (selectedDiscountType === "%") {
        if (Number(discountAmount) > 100) {
          return toast("%는 100보다 작아야합니다");
        }
      }

      if (selectedPeriodType !== "만료일 설정") {
        if (!startDate) {
          toast("시작날짜를 선택해주세요.");
          return;
        }

        if (!noPeriodLimit) {
          if (!endDate) {
            toast("종료날짜를 선택해주세요.");
            return;
          }
        }
      }

      if (selectedPeriodType === "만료일 설정") {
        if (!noPeriodLimit) {
          if (expiredDay === 0 || expiredDay === "") {
            toast("사용기간을 입력해주세요.");
            return;
          }

          if (!isNumericString(String(expiredDay))) {
            toast("사용기간은 숫자만 입력가능합니다.");
            return;
          }
        }
      }

      let exceptionMerchIdListTemp = exceptionMerchIdList.map(
        (item) => item.id
      );
      let merchIdListTemp = merchIdList.map((item) => item.id);

      let data = {
        title: title,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: noPeriodLimit
          ? null
          : endDate == null
          ? null
          : moment(endDate).format("YYYY-MM-DD"),
        expiredDay: noPeriodLimit ? 0 : Number(expiredDay),
        allowDuplicate: allowDuplicate,
        discountAmount: Number(discountAmount),
        maxDiscountAmount: Number(maxDiscountAmount),
        minBuyAmount: Number(minBuyAmount),
        useAlarm: selectedAlarm === "발행일에 알림" ? true : false,
        merchMainCategoryId: selectedCategory,
        merchIdList: merchIdListTemp,
        exceptionMerchIdList: exceptionMerchIdListTemp,
      };

      if (selectedBenefit === "금액할인") {
        if (selectedDiscountType === "KRW") {
          data.couponUseType = "KRW";
        } else {
          data.couponUseType = "PERCENT";
        }
      } else {
        if (selectedTicket === "1년 수강권") {
          data.couponUseType = "ANNUAL";
        } else {
          data.couponUseType = "LIFETIME";
        }
      }

      if (selectedRange === "모든 상품") {
        data.couponScope = "ALL";
      } else if (selectedRange === "지정 카테고리") {
        data.couponScope = "CATEGORY";
      } else {
        data.couponScope = "MERCH";
      }

      switch (selectedRadio) {
        case "지정발행":
          data = {
            ...data,
            couponType: "ASIGN",
            couponTarget: selectedTarget === "전체회원" ? "ALL" : "GROUP",
            groupId: selectedTarget === "전체회원" ? 0 : selectedGroup,
            // issueCount: 0, // defalut로 보낼지 지우고 안보낼지..
            couponPeriod: "SETTING",

            // couponCodeType: "SINGLE", // defalut로 보낼지 지우고 안보낼지..
            // couponCode: "", // defalut로 보낼지 지우고 안보낼지..
          };
          break;

        case "고객 다운로드":
          data = {
            ...data,
            couponType: "DOWNLOAD",
            // couponTarget: "ALL", // defalut로 보낼지 지우고 안보낼지..
            // groupId: 0, // defalut로 보낼지 지우고 안보낼지..
            issueCount: issueCount,
            couponPeriod:
              selectedPeriodType === "기간설정" ? "SETTING" : "EXPIRE",

            // couponCodeType: "SINGLE", // defalut로 보낼지 지우고 안보낼지..
            // couponCode: "", // defalut로 보낼지 지우고 안보낼지..
          };
          break;

        case "자동발행":
          data = {
            ...data,
            couponType: "AUTO",
            couponTarget:
              selectedAutoTarget === "첫 회원가입"
                ? "FIRST_JOIN"
                : "FIRST_PURCHASE",
            // groupId: 0, // defalut로 보낼지 지우고 안보낼지..
            // issueCount: 0, // defalut로 보낼지 지우고 안보낼지..
            couponPeriod: "EXPIRE",

            // couponCodeType: "SINGLE", // defalut로 보낼지 지우고 안보낼지..
            // couponCode: "", // defalut로 보낼지 지우고 안보낼지..
          };
          break;

        case "쿠폰코드 생성":
          data = {
            ...data,
            couponType: "CODE",
            // couponTarget: "ALL", // defalut로 보낼지 지우고 안보낼지..
            // groupId: 0, // defalut로 보낼지 지우고 안보낼지..
            // issueCount: 0, // defalut로 보낼지 지우고 안보낼지..
            couponPeriod: "SETTING",

            issueCount: issueCount,
            couponCodeType:
              selectedCouponType === "단일 쿠폰코드" ? "SINGLE" : "MULTIPLE",
            couponCode: couponCode ? couponCode : generateRandomString(),
          };
          break;

        default:
          break;
      }

      await CouponApi.create(data);

      toast(toastMsg.create);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>쿠폰 추가</TableTitle>
          {/* ********** 쿠폰 정보 영역 ********** */}
          <CouponSubTItle
            style={{
              marginTop: 40,
            }}
          >
            쿠폰 정보
          </CouponSubTItle>

          {/* 쿠폰 정보 - 쿠폰명 */}
          <CouponInputWrapper>
            <CouponInputTitle>쿠폰명</CouponInputTitle>
            <MainInput
              type={"text"}
              placeholder={"내용을 입력해 주세요."}
              style={{ width: "572px" }}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </CouponInputWrapper>

          {/* 쿠폰 정보 - 쿠폰 형식 */}
          <CouponInputWrapper
            style={{
              alignItems: "flex-start",
            }}
          >
            <CouponInputTitle>쿠폰 형식</CouponInputTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <Radio
                id={""}
                valueText={"지정발행"}
                checked={selectedRadio === "지정발행"}
                onChange={() => {
                  setSelectedRadio("지정발행");
                }}
              />

              {/* <Radio
                id={""}
                valueText={"고객 다운로드"}
                checked={selectedRadio === "고객 다운로드"}
                onChange={() => {
                  setSelectedRadio("고객 다운로드");
                }}
              /> */}

              <Radio
                id={""}
                valueText={"자동발행"}
                checked={selectedRadio === "자동발행"}
                onChange={() => {
                  setSelectedRadio("자동발행");
                }}
              />
              <Radio
                id={""}
                valueText={"쿠폰코드 생성"}
                checked={selectedRadio === "쿠폰코드 생성"}
                onChange={() => {
                  setSelectedRadio("쿠폰코드 생성");
                }}
              />
            </div>
          </CouponInputWrapper>

          {selectedRadio !== "쿠폰코드 생성" && (
            <>
              {/* 쿠폰 정보 - 발행대상 */}

              {selectedRadio !== "고객 다운로드" && (
                <>
                  <CouponInputWrapper>
                    <CouponInputTitle>발행대상</CouponInputTitle>
                    {selectedRadio !== "자동발행" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        <SelectBoxValue
                          placeholder="발행대상을 선택해주세요"
                          selectedValue={selectedTarget}
                          isOpen={targetListBoxOpen}
                          wrapperHandler={() => {
                            setTargetListBoxOpen(!targetListBoxOpen);
                          }}
                          itemList={targetList}
                          selectedValueSetterFunc={(value) => {
                            setSelectedTarget(value);
                            setTargetListBoxOpen(false);
                          }}
                        />
                        {selectedTarget === "지정그룹" && (
                          <SelectBoxValue
                            placeholder="그룹 선택"
                            selectedValue={selectedGroup}
                            isOpen={groupListBoxOpen}
                            wrapperHandler={() => {
                              setGroupListBoxOpen(!groupListBoxOpen);
                            }}
                            itemList={groupList}
                            selectedValueSetterFunc={(value) => {
                              setSelectedGroup(value);
                              setGroupListBoxOpen(false);
                            }}
                          />
                        )}
                      </div>
                    )}

                    {selectedRadio === "자동발행" && (
                      <SelectBoxValue
                        placeholder="발행대상을 선택해주세요"
                        selectedValue={selectedAutoTarget}
                        isOpen={autoTargetListOpen}
                        wrapperHandler={() => {
                          setAutoTargetListOpen(!autoTargetListOpen);
                        }}
                        itemList={autoTargetList}
                        selectedValueSetterFunc={(value) => {
                          setSelectedAutoTarget(value);
                          setAutoTargetListOpen(false);
                        }}
                      />
                    )}
                  </CouponInputWrapper>
                </>
              )}

              {/* 쿠폰 정보 - 발행 수량(고객 다운로드 선택한 경우 한) */}
              {selectedRadio === "고객 다운로드" && (
                <CouponInputWrapper
                  style={{
                    alignItems: "flex-start",
                  }}
                >
                  <CouponInputTitle
                    style={{
                      marginTop: 10,
                    }}
                  >
                    발행 수량
                  </CouponInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <MainInput
                      type={"text"}
                      placeholder={"0"}
                      style={{
                        width: "338px",
                        marginBottom: "10px",
                      }}
                      value={issueCount}
                      onChange={(e) => {
                        setIssueCount(e.target.value);
                      }}
                    />
                    <CheckboxWrapper
                      onClick={() => {
                        setIsIssueCountInfinity(!isIssueCountInfinity);
                      }}
                    >
                      <Checkbox
                        style={{
                          backgroundColor: "transparent",
                        }}
                        checked={isIssueCountInfinity}
                        onChange={() => {
                          setIsIssueCountInfinity(!isIssueCountInfinity);
                        }}
                      />
                      <CheckboxText
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                          color: "#aaa",
                        }}
                      >
                        개수 제한 없음
                      </CheckboxText>
                    </CheckboxWrapper>
                    <PretendardText
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        lineHeight: "18.75px",
                        color: "rgba(181, 181, 181, 0.5)",
                        marginTop: 5,
                      }}
                    >
                      [발행수량]은 쿠폰 발급 가능 총 수량을 제한하여 선착순으로
                      한정된 인원에게 쿠폰을 지급하는 수량으로
                      <br />
                      ‘개수 제한 없음’ 선택 시 수량 제한 없이 쿠폰을 발급받을 수
                      있습니다
                    </PretendardText>
                  </div>
                </CouponInputWrapper>
              )}

              {/* 쿠폰 정보 - 발행알림 */}
              <CouponInputWrapper>
                <CouponInputTitle>발행알림</CouponInputTitle>
                <SelectBoxValue
                  placeholder="발행알림을 선택해주세요"
                  selectedValue={selectedAlarm}
                  isOpen={alarmListBoxOpen}
                  wrapperHandler={() => {
                    setAlarmListBoxOpen(!alarmListBoxOpen);
                  }}
                  itemList={alarmList}
                  selectedValueSetterFunc={(value) => {
                    setSelectedAlarm(value);
                    setAlarmListBoxOpen(false);
                  }}
                />
              </CouponInputWrapper>
            </>
          )}

          {selectedRadio === "쿠폰코드 생성" && (
            <CouponInputWrapper>
              <CouponInputTitle>쿠폰코드</CouponInputTitle>
              <div
                style={{
                  display: "flex",
                  gap: 12,
                }}
              >
                <SelectBoxValue
                  placeholder=""
                  selectedValue={selectedCouponType}
                  isOpen={couponTypeListBoxOpen}
                  wrapperHandler={() => {
                    setCouponTypeListBoxOpen(!couponTypeListBoxOpen);
                  }}
                  itemList={couponTypeList}
                  selectedValueSetterFunc={(value) => {
                    setSelectedCouponType(value);
                    setCouponTypeListBoxOpen(false);
                  }}
                />
                {selectedCouponType === "단일 쿠폰코드" && (
                  <MainInput
                    type={"text"}
                    placeholder={"쿠폰코드 입력(입력하지 않으면 랜덤생성"}
                    style={{ width: "338px" }}
                    value={couponCode}
                    onChange={(e) => {
                      setCouponCode(e.target.value);
                    }}
                  />
                )}
                {selectedCouponType === "여러 쿠폰코드" && (
                  <MainInput
                    type={"text"}
                    placeholder={"발급수량(최대 500개)"}
                    style={{ width: "338px" }}
                    value={issueCount}
                    onChange={(e) => {
                      setIssueCount(e.target.value);
                    }}
                  />
                )}
              </div>
            </CouponInputWrapper>
          )}

          {/* ********** 사용 정보 영역 ********** */}
          <CouponSubTItle
            style={{
              marginTop: 50,
            }}
          >
            사용 정보
          </CouponSubTItle>

          {/* 사용 정보 - 사용혜택 */}
          <CouponInputWrapper>
            <CouponInputTitle>사용혜택</CouponInputTitle>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
              }}
            >
              <SelectBoxValue
                placeholder="사용혜택을 선택해주세요"
                selectedValue={selectedBenefit}
                isOpen={benefitListBoxOpen}
                wrapperHandler={() => {
                  setBenefitListBoxOpen(!benefitListBoxOpen);
                }}
                itemList={benefitList}
                selectedValueSetterFunc={(value) => {
                  setSelectedBenefit(value);
                  setBenefitListBoxOpen(false);
                }}
              />
              {selectedBenefit === "금액할인" && (
                <>
                  <MainInput
                    type={"text"}
                    placeholder={"0"}
                    style={{
                      width: "338px",
                      textAlign: "right",
                    }}
                    value={discountAmount}
                    onChange={(e) => {
                      setDiscountAmount(e.target.value);
                    }}
                  />
                  <SelectBoxValue
                    isSmall={true}
                    placeholder="KRW"
                    selectedValue={selectedDiscountType}
                    isOpen={discountTypeListBoxOpen}
                    wrapperHandler={() => {
                      setDiscountTypeListBoxOpen(!discountTypeListBoxOpen);
                    }}
                    itemList={discountTypeList}
                    selectedValueSetterFunc={(value) => {
                      setSelectedDiscountType(value);
                      setDiscountTypeListBoxOpen(false);
                    }}
                  />
                </>
              )}
              {selectedBenefit === "수강권 혜택" && (
                <SelectBoxValue
                  placeholder="수강권 선택"
                  selectedValue={selectedTicket}
                  isOpen={ticketListBoxOpen}
                  wrapperHandler={() => {
                    setTicketListBoxOpen(!ticketListBoxOpen);
                  }}
                  itemList={ticketList}
                  selectedValueSetterFunc={(value) => {
                    setSelectedTicket(value);
                    setTicketListBoxOpen(false);
                  }}
                />
              )}
            </div>
          </CouponInputWrapper>

          {selectedBenefit === "수강권 혜택" ? null : (
            <>
              {selectedDiscountType === "%" ? (
                <CouponInputWrapper>
                  <CouponInputTitle>최대 할인금액</CouponInputTitle>
                  <MainInput
                    type={"text"}
                    placeholder={"KRW"}
                    style={{
                      width: "338px",
                    }}
                    value={maxDiscountAmount}
                    onChange={(e) => {
                      setMaxDiscountAmount(e.target.value);
                    }}
                  />
                </CouponInputWrapper>
              ) : null}

              {/* 사용 정보 - 최소 구매금액 */}
              <CouponInputWrapper>
                <CouponInputTitle>최소 구매금액</CouponInputTitle>
                <MainInput
                  type={"text"}
                  placeholder={"KRW"}
                  style={{
                    width: "338px",
                  }}
                  value={minBuyAmount}
                  onChange={(e) => {
                    setMinBuyAmount(e.target.value);
                  }}
                />
              </CouponInputWrapper>

              {/* 사용 정보 - 쿠폰 적용 범위 */}
              <CouponInputWrapper
                style={{
                  alignItems: "flex-start",
                }}
              >
                <CouponInputTitle
                  style={{
                    marginTop: 10,
                  }}
                >
                  쿠폰 적용 범위
                </CouponInputTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 12,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <SelectBoxValue
                      placeholder="쿠폰 적용 범위를 선택해주세요"
                      selectedValue={selectedRange}
                      isOpen={rangeListBoxOpen}
                      wrapperHandler={() => {
                        setRangeListBoxOpen(!rangeListBoxOpen);
                      }}
                      itemList={rangeList}
                      selectedValueSetterFunc={(value) => {
                        setSelectedRange(value);
                        setRangeListBoxOpen(false);
                      }}
                    />
                    {selectedRange === "지정 카테고리" && (
                      <SelectBoxValue
                        placeholder="카테고리 선택"
                        selectedValue={selectedCategory}
                        isOpen={categoryListBoxOpen}
                        wrapperHandler={() => {
                          setCategoryListBoxOpen(!categoryListBoxOpen);
                        }}
                        itemList={categoryList}
                        selectedValueSetterFunc={(value) => {
                          setSelectedCategory(value);
                          setCategoryListBoxOpen(false);
                        }}
                      />
                    )}
                  </div>
                  {selectedRange === "지정 상품" && (
                    <>
                      <GrayBtn
                        onClick={() => {
                          setCouponApplyProductPopupOpen(true);
                        }}
                        text="쿠폰 적용 상품 선택"
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {merchIdList.map((mItem, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 10,
                                padding: "15px 0px",
                                borderBottom:
                                  "0.5px solid rgba(255, 255, 255, 0.12)",
                              }}
                            >
                              <PretendardText
                                className="truncate"
                                style={{
                                  width: 500,
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  lineHeight: "22px",
                                  color: "#aaa",
                                }}
                              >
                                {mItem.title}
                              </PretendardText>
                              <RedBtn
                                style={{
                                  backgroundColor: "#313233",
                                }}
                                onClick={() => {
                                  const temp = merchIdList.filter(
                                    (mItemF) => mItemF.id !== mItem.id
                                  );
                                  setMerchIdList(temp);
                                }}
                              >
                                삭제
                              </RedBtn>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </CouponInputWrapper>

              {/* 사용 정보 - 사용제외 상품 */}
              <CouponInputWrapper
                style={{
                  alignItems: "flex-start",
                }}
              >
                <CouponInputTitle>사용제외 상품</CouponInputTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 12,
                  }}
                >
                  <GrayBtn
                    onClick={() => {
                      setECouponApplyProductPopupOpen(true);
                    }}
                    text="쿠폰 적용 제외 상품 선택"
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {exceptionMerchIdList.map((mItem, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 10,
                            padding: "15px 0px",
                            borderBottom:
                              "0.5px solid rgba(255, 255, 255, 0.12)",
                          }}
                        >
                          <PretendardText
                            className="truncate"
                            style={{
                              width: 500,
                              fontSize: "14px",
                              fontWeight: "400",
                              lineHeight: "22px",
                              color: "#aaa",
                            }}
                          >
                            {mItem.title}
                          </PretendardText>
                          <RedBtn
                            style={{
                              backgroundColor: "#313233",
                            }}
                            onClick={() => {
                              const temp = exceptionMerchIdList.filter(
                                (mItemF) => mItemF.id !== mItem.id
                              );
                              setExceptionMerchIdList(temp);
                            }}
                          >
                            삭제
                          </RedBtn>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </CouponInputWrapper>
            </>
          )}

          {/* 사용 정보 - 사용기간 영역 */}
          <CouponInputWrapper
            style={{
              alignItems: "flex-start",
            }}
          >
            <CouponInputTitle
              style={{
                marginTop: selectedRadio === "자동발행" ? 14 : 0,
              }}
            >
              사용기간
            </CouponInputTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              {selectedRadio === "고객 다운로드" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                    marginBottom: 14,
                  }}
                >
                  <Radio
                    id={""}
                    valueText={"기간설정"}
                    checked={selectedPeriodType === "기간설정"}
                    onChange={() => {
                      setSelectedPeriodType("기간설정");
                    }}
                  />
                  <Radio
                    id={""}
                    valueText={"만료일 설정"}
                    checked={selectedPeriodType === "만료일 설정"}
                    onChange={() => {
                      setSelectedPeriodType("만료일 설정");
                    }}
                  />
                </div>
              )}
              {selectedPeriodType !== "만료일 설정" &&
                selectedRadio !== "자동발행" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <DateInput
                      value={moment(startDate).format("YYYY-MM-DD")}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                    />
                    <span
                      style={{
                        width: 6,
                        height: 1,
                        backgroundColor: "rgba(181, 181, 181, 0.5)",
                      }}
                    />
                    <DateInput
                      value={moment(endDate).format("YYYY-MM-DD")}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                    />
                  </div>
                )}

              {(selectedPeriodType === "만료일 설정" ||
                selectedRadio === "자동발행") && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <PretendardText
                    style={{
                      fontWeight: "500",
                      fontSize: "15px",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    다운로드 일로부터
                  </PretendardText>
                  <MainInput
                    type={"text"}
                    placeholder={"0"}
                    style={{ width: "93px" }}
                    value={expiredDay}
                    onChange={(e) => {
                      setExpiredDay(e.target.value);
                    }}
                  />
                  <PretendardText
                    style={{
                      fontWeight: "500",
                      fontSize: "15px",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    일 후 까지 사용 가능
                  </PretendardText>
                </div>
              )}
              <CheckboxWrapper
                onClick={() => {
                  setNoPeriodLimit(!noPeriodLimit);
                }}
              >
                <Checkbox
                  style={{
                    backgroundColor: "transparent",
                  }}
                  checked={noPeriodLimit}
                  onChange={() => {
                    setNoPeriodLimit(!noPeriodLimit);
                  }}
                />
                <CheckboxText
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    lineHeight: "21.5px",
                    color: "#aaa",
                  }}
                >
                  기간 제한 없음
                </CheckboxText>
              </CheckboxWrapper>
            </div>
          </CouponInputWrapper>

          {/* 사용 정보 - 사용 옵션 영역 */}
          {/* <CouponInputWrapper
            style={{
              alignItems: "flex-start",
            }}
          >
            <CouponInputTitle>사용 옵션</CouponInputTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
              <CheckboxWrapper
                onClick={() => {
                  setAllowDuplicate(!allowDuplicate);
                }}
              >
                <Checkbox
                  style={{
                    backgroundColor: "transparent",
                  }}
                  checked={allowDuplicate}
                  onChange={() => {
                    setAllowDuplicate(!allowDuplicate);
                  }}
                />
                <CheckboxText
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    lineHeight: "21.5px",
                    color: "#aaa",
                  }}
                >
                  쿠폰 중복 사용 가능
                </CheckboxText>
              </CheckboxWrapper>
              <PretendardText
                style={{
                  fontWeight: "500",
                  fontSize: "13px",
                  lineHeight: "18.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                  marginTop: 5,
                }}
              >
                한 상품에 쿠폰을 2개 이상 적용 가능합니다
                <br />
                이 기능에 체크한 쿠폰과 체크하지 않은 쿠폰을 함께 사용할 수
                있으며,
                <br />
                체크하지 않은 쿠폰끼리는 사용할 수 없습니다
              </PretendardText>
            </div>
          </CouponInputWrapper> */}

          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <BasicBtn
              onClick={() => {
                createProductFunc();
              }}
            >
              저장하기
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>

      {/* 지정 상품 추가 팝업 */}
      {couponApplyProductPopupOpen && (
        <RelatedProductsPopup
          setPopupOpen={setCouponApplyProductPopupOpen}
          setValue={setMerchIdList}
          value={merchIdList}
          exclusionList={exceptionMerchIdList}
        />
      )}

      {/* 지정 상품 추가 팝업 */}
      {eCouponApplyProductPopupOpen && (
        <RelatedProductsPopup
          setPopupOpen={setECouponApplyProductPopupOpen}
          setValue={setExceptionMerchIdList}
          value={exceptionMerchIdList}
          exclusionList={merchIdList}
        />
      )}
    </>
  );
};

export default OperationCouponCreate;

const CouponSubTItle = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 18px;
  line-height: 32.5px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;

const CouponInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  padding: 21px 0px;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const CouponInputTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
